import Vue from 'vue'

Vue.filter('percent', (value, suffix) => {
  value = (value * 100).toFixed(2)
  suffix = suffix === undefined ? '%' : '';

  return value + suffix
})
